/**
 * Translation service — DISABLED.
 *
 * This used to fetch each item's localized name from the Divine Pride API on
 * mount, walking the entire ~1,600-item catalog on every page load. Those names
 * are ALREADY bundled in src/db/itemsPt.json and itemsEn.json (every item has a
 * `name` field), so the fetches were pure waste and a major source of API load.
 *
 * The item-list components fall back to `item.name` (the bundled name) whenever
 * getTranslatedItemName returns null, so these no-ops keep names working with
 * zero network requests. Kept as stubs to preserve the import surface.
 */

/**
 * Always returns null → callers use the bundled item.name.
 */
export const getTranslatedItemName = () => null;

/**
 * No-op. Names are bundled, so there is nothing to queue.
 */
export const queueItemsForTranslation = (items, language, onBatchComplete) => {
  if (typeof onBatchComplete === 'function') {
    onBatchComplete();
  }
};

/**
 * No-op. Kept so main.js can call it without changes.
 */
export const initializeTranslations = () => {};
